window.GT_PRODUCTS = {
  "GT-01": {
    "catalog": "001",
    "name": "BIG SUR",
    "subtitle": "10-spoke split-y",
    "weight": "9.2 kg",
    "spokes": "10",
    "lead": "6-8 wk",
    "price": 1125,
    "copy": "A lightweight forged monoblock made for fast road, canyon, and track use. Clean split-y geometry, motorsport proportions, and a deep barrel profile give it a purposeful modern stance.",
    "productHandle": "gt-01-big-sur-forged-wheel"
  },
  "GT-02": {
    "catalog": "002",
    "name": "HALF MOON",
    "subtitle": "6-spoke motorsport",
    "weight": "9.8 kg",
    "spokes": "6",
    "lead": "6-8 wk",
    "price": 1125,
    "copy": "A strong six-spoke forged wheel inspired by endurance racing. Built for brake clearance, easy cleaning, and a simple timeless profile.",
    "productHandle": "gt-02-half-moon-forged-wheel"
  },
  "GT-03": {
    "catalog": "003",
    "name": "SONOMA",
    "subtitle": "multi-spoke forged",
    "weight": "9.6 kg",
    "spokes": "12",
    "lead": "6-8 wk",
    "price": 1125,
    "copy": "A technical multi-spoke design for drivers who want a more detailed motorsport look without giving up strength, stiffness, or daily usability.",
    "productHandle": "gt-03-sonoma-forged-wheel"
  },
  "GT-04": {
    "catalog": "004",
    "name": "MONTEREY",
    "subtitle": "split mesh forged",
    "weight": "10.1 kg",
    "spokes": "split mesh",
    "lead": "6-8 wk",
    "price": 1125,
    "copy": "A split-mesh forged wheel with a tight, intricate spoke pattern and a deep concave profile. The Monterey fills the face of the wheel with detail — thin spokes woven into a dense mesh that catches light from every angle.",
    "productHandle": "gt-04-monterey-forged-wheel"
  },
  "GT-05": {
    "catalog": "005",
    "name": "CATALINA",
    "subtitle": "directional multi-spoke",
    "weight": "9.9 kg",
    "spokes": "multi-spoke",
    "lead": "6-8 wk",
    "price": 1125,
    "copy": "A directional multi-spoke forged wheel with a turbine-inspired face. Thin, tightly packed spokes sweep outward from the center, giving the Catalina an aggressive rotational look that stands out at speed and at rest.",
    "productHandle": "gt-05-catalina-forged-wheel"
  },
  "GT-01C": {
    "catalog": "001C",
    "name": "BIG SUR CL",
    "subtitle": "center-lock split-y",
    "weight": "9.4 kg",
    "spokes": "10",
    "lead": "6-8 wk",
    "price": 1125,
    "copy": "A center-lock version of the GT-01 split-y design. Built specifically for center-lock Porsche fitments with a clean motorsport face and lightweight forged construction.",
    "centerLockOnly": true,
    "productHandle": "gt-01c-big-sur-cl-forged-wheel"
  },
  "GT-06": {
    "catalog": "006",
    "name": "LAGUNA",
    "subtitle": "radial multi-spoke forged",
    "weight": "9.5 kg",
    "spokes": "multi-spoke",
    "lead": "6-8 wk",
    "price": 1125,
    "copy": "A high-spoke-count forged monoblock with layered radial geometry and a deep stepped lip. The Laguna draws from rally and grand touring heritage \u2014 tightly woven spokes create visual density and structural rigidity while the aggressive outer ring adds a mechanical edge.",
    "productHandle": "gt-06-laguna-forged-wheel"
  },
  "GT-07": {
    "catalog": "007",
    "name": "MULHOLLAND",
    "subtitle": "cross-mesh forged",
    "weight": "9.7 kg",
    "spokes": "cross-mesh",
    "lead": "6-8 wk",
    "price": 1125,
    "copy": "A stunning cross-mesh forged wheel named after California's most iconic driving road. The Mulholland blends classic motorsport geometry with modern deep-dish aesthetics, offering incredible structural rigidity for aggressive canyon carving.",
    "productHandle": "gt-07-mulholland-forged-wheel"
  }
};

window.GT_SIZE_PRICES = {
  "GT-01":  { 15: 975, 16: 1000, 17: 1050, 18: 1075, 19: 1125, 20: 1175, 21: 1225, 22: 1275 },
  "GT-02":  { 15: 975, 16: 1000, 17: 1050, 18: 1075, 19: 1125, 20: 1175, 21: 1225, 22: 1275 },
  "GT-01C": { 15: 975, 16: 1000, 17: 1050, 18: 1075, 19: 1125, 20: 1175, 21: 1225, 22: 1275 },
  "GT-03":  { 15: 975, 16: 1000, 17: 1050, 18: 1075, 19: 1125, 20: 1175, 21: 1225, 22: 1275 },
  "GT-04":  { 15: 975, 16: 1000, 17: 1050, 18: 1075, 19: 1125, 20: 1175, 21: 1225, 22: 1275 },
  "GT-05":  { 15: 975, 16: 1000, 17: 1050, 18: 1075, 19: 1125, 20: 1175, 21: 1225, 22: 1275 },
  "GT-06":  { 15: 975, 16: 1000, 17: 1050, 18: 1075, 19: 1125, 20: 1175, 21: 1225, 22: 1275 },
  "GT-07":  { 15: 975, 16: 1000, 17: 1050, 18: 1075, 19: 1125, 20: 1175, 21: 1225, 22: 1275 }
};